import {Inject, Injectable, LOCALE_ID} from '@angular/core';
import {DatePipe} from "@angular/common";

@Injectable({
  providedIn: 'root'
})
export class DateHelperService {

  constructor(@Inject(LOCALE_ID) private locale: string,) {
  }

  /**
   * Transorme une date au format Django YYYY-MM-DD
   * @param date
   * @return string
   */
  transformDateToYYYYMMDD(date) {
    const dt: DatePipe = new DatePipe(this.locale);
    const date_return = dt.transform(date, 'yyyy-MM-dd');
    return date_return;
  }

  /**
   * On retire les WE
   * @param {Date} d
   * @returns {boolean}
   */
  filterWE(d: Date): boolean {
    if (d) {
      const day = d.getDay();
      return day !== 0 && day !== 6;
    }
    return true;
  }
}
